import firebase from 'firebase'

export const getQuantity = (arr) => {
  let count = 0
  for (let i in arr) {
    if (arr[i].quantity) {
      count += arr[i].quantity
    }
  }
  return count
}

export const getToken = () => {
  if (localStorage.user) {
    let localUser = JSON.parse(localStorage.user)
    return localUser.uid
  }
  let currentUser = firebase.auth().currentUser
  return currentUser ? currentUser.uid : null
}



// WEBPACK FOOTER //
// ./src/helpers.js